import { useEffect, useState } from "react";
import { AxiosPrivado } from "../../componentes/axios/Axios";
import {
    CargosListar, ClienteListar, EmpleadosListar
} from "../../configuracion/apiUrls";
import { useContextUsuario } from "../usuario/UsuarioContext";
import { EmpleadoContext } from "./EmpleadoContext";

export const EmpleadoState = (props) => {
    const { token } = useContextUsuario();
    const [empleado, setEmpleado] = useState(null);
    const [listaEmpleados, setListaEmpleados] = useState([]);
    const [listaCargos, setListaCargos] = useState([]);
    const [listaClientes, setListaClientes] = useState([]);
    const [actualizar, setActualizar] = useState(false);

    useEffect(() => {
        //Lista();
    }, []);


    const Lista = async () => {
        try {
            await ActualizarLista(EmpleadosListar, setListaEmpleados);
            await ActualizarLista(CargosListar, setListaCargos);
            await ActualizarLista(ClienteListar, setListaClientes);
        } catch (error) {
            console.log(error);
        }
    };

    const ActualizarLista = async (url, setDatos) => {
        AxiosPrivado.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        try {
            const respuesta = await AxiosPrivado.get(url);
            setDatos(respuesta.data);
        } catch (error) {
            console.log(error);
            setDatos([]);
        }
    };

    return (
        <EmpleadoContext.Provider
            value={{
                empleado,
                listaEmpleados,
                listaCargos,
                listaClientes,
                actualizar,
                setActualizar,
                setEmpleado,
                setListaEmpleados,
                setListaCargos,
                setListaClientes,
                Lista,
                ActualizarLista,
            }}
        >
            {props.children}
        </EmpleadoContext.Provider>
    );
};
